"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@repo/ui/aops-components/typography";
import styles from "./TabButton.module.css";
import { CarouselContext } from "../CarouselContext";
import { useContext, useEffect, useRef } from "react";
export default function TabButton(t0) {
  const $ = _c(18);
  const {
    index,
    text,
    iconUrl,
    accentColor: t1
  } = t0;
  const accentColor = t1 === undefined ? "--color-surface-accent-blue" : t1;
  const {
    activeIndex,
    setActiveIndex
  } = useContext(CarouselContext);
  const buttonRef = useRef(null);
  const isActive = index === activeIndex;
  const wasActiveRef = useRef(isActive);
  let t2;
  let t3;
  if ($[0] !== isActive) {
    t2 = () => {
      const becameActive = isActive && !wasActiveRef.current;
      wasActiveRef.current = isActive;
      if (!becameActive) {
        return;
      }
      const button = buttonRef.current;
      const container = button?.parentElement;
      if (!button || !container) {
        return;
      }
      const buttonRect = button.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const overflowLeft = buttonRect.left - containerRect.left;
      const overflowRight = buttonRect.right - containerRect.right;
      if (overflowLeft < 0) {
        container.scrollBy({
          left: overflowLeft,
          behavior: "smooth"
        });
      } else {
        if (overflowRight > 0) {
          container.scrollBy({
            left: overflowRight,
            behavior: "smooth"
          });
        }
      }
    };
    t3 = [isActive];
    $[0] = isActive;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== index || $[4] !== setActiveIndex) {
    t4 = () => setActiveIndex(index);
    $[3] = index;
    $[4] = setActiveIndex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `var(${accentColor})`;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      "--accent-color": t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = t6 as React.CSSProperties;
  let t8;
  if ($[8] !== iconUrl) {
    t8 = iconUrl && <span className={styles.icon} style={{
      "--icon-url": `url(${iconUrl})`
    } as React.CSSProperties} aria-hidden={true} />;
    $[8] = iconUrl;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== text) {
    t9 = <Typography as="span" variant="body">{text}</Typography>;
    $[10] = text;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isActive || $[13] !== t4 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div ref={buttonRef} role="button" onClick={t4} className={styles.tabButton} data-active={isActive} style={t7}>{t8}{t9}</div>;
    $[12] = isActive;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}